export default {
    // 消息中间件信息查询接口
    listMqInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/listMqInfo', params, response);
    },
    // 消息中间件删除接口
    deleteMqInfo(params, response) {
        window.vue.$apiAxios.delete('/databusserver/interfaceManager/deleteMqInfo', params, response);
    },
    // 消息添加接口
    insertMqInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/insertMqInfo', params, response);
    },
    // 消息更新接口
    updateMqInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/updateMqInfo', params, response);
    },
    // 下传配置接口
    distributeConfigInfo(params, response) {
        window.vue.$apiAxios.get('/databusserver/mqInfo/distributeConfigInfo', params, response);
    },
    // 检测MQip和端口号是否重复
    checkIpPortRepeat(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/checkIpPortRepeat', params, response);
    },
    // 检测mq服务能否连接成功
    checkMqConnection(params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/checkMqConnection', params, response);
    }
};
